import { render } from "./Home4F.vue?vue&type=template&id=74e7dda4&scoped=true"
import script from "./Home4F.vue?vue&type=script&lang=ts"
export * from "./Home4F.vue?vue&type=script&lang=ts"

import "./Home4F.vue?vue&type=style&index=0&id=74e7dda4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-74e7dda4"

export default script